import React from 'react';

/** Small 18px stroke icons for the results header actions. */
const Icon: React.FC<{ children: React.ReactNode; className?: string }> = ({ children, className }) => (
    <svg
        className={`action-icon${className ? ` ${className}` : ''}`}
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
        aria-hidden="true"
        focusable="false"
    >
        {children}
    </svg>
);

export const LinkIcon: React.FC = () => (
    <Icon>
        <path d="M10 13a5 5 0 0 0 7.07 0l3-3a5 5 0 0 0-7.07-7.07l-1.5 1.5" />
        <path d="M14 11a5 5 0 0 0-7.07 0l-3 3a5 5 0 0 0 7.07 7.07l1.5-1.5" />
    </Icon>
);

export const DownloadIcon: React.FC = () => (
    <Icon>
        <path d="M12 3v12" />
        <path d="M7 10l5 5 5-5" />
        <path d="M5 21h14" />
    </Icon>
);

export const CheckIcon: React.FC = () => (
    <Icon>
        <path d="M5 12.5l4.5 4.5L19 7.5" />
    </Icon>
);

export const ExternalLinkIcon: React.FC = () => (
    <Icon>
        <path d="M14 4h6v6" />
        <path d="M20 4l-9 9" />
        <path d="M18 14v5a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1V7a1 1 0 0 1 1-1h5" />
    </Icon>
);

export const SpinnerIcon: React.FC = () => (
    <Icon className="is-spinning">
        <path d="M12 3a9 9 0 1 0 9 9" />
    </Icon>
);
